export const imageDescriptions: Record<string, string> = {
  "2023-seo-lessons-and-forward-view":
    "Search results, a magnifying glass and a stepping-stone roadmap illustrating SEO planning",
  "2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns":
    "Search filters, security and analytics gears illustrating core and spam algorithm updates",
  "a-practical-plan-for-ai-driven-search-a-ninety-day-playbook":
    "SEO research, content and analytics milestones in a ninety-day action plan",
  "a-year-of-change-googles-2021-algorithm-updates":
    "Search dial, content cards and reviewer profile illustrating search algorithm changes",
  accountants:
    "Calculator, financial reports and an accountancy website illustrating SEO for accountants",
  "ai-in-search-the-rise-of-generative-experiences":
    "Website sources passing through a search lens into a generated answer card",
  "aligning-seo-with-revenue-goals-in-2025":
    "Customer, enquiry, sale and revenue milestones linked in an SEO conversion journey",
  "barnsley-seo-for-accountants-how-to-attract-higher-value-leads":
    "Calculator, business profile and location pin illustrating SEO for Barnsley accountants",
  "barnsley-seo-for-builders-how-to-turn-google-searches-into-quote-requests":
    "House extension, builders, project plans and location pin illustrating local builders SEO",
  "barnsley-seo-for-dental-and-health-clinics-local-patient-growth":
    "Tooth, appointment calendar and location pin illustrating local dental search and bookings",
  "barnsley-seo-for-solicitors-building-trust-and-qualified-enquiries":
    "Legal scales, verified enquiry and location pin illustrating local SEO for solicitors",
  "bert-expansion-and-passage-indexing":
    "Magnifying glass highlighting a passage in an open book, illustrating passage indexing",
  "building-a-website-that-supports-seo-and-business-growth":
    "Responsive website on a bridge with a growth arrow illustrating website foundations for SEO",
  "building-structured-data-and-schema-markup":
    "Structured code blocks connected to a search result with review stars",
  "common-seo-mistakes-that-hold-small-businesses-back":
    "Obstacles removed from a route between search and a customer enquiry",
  "connecting-seo-to-revenue-in-an-ai-influenced-world-revision":
    "Search, chat and content channels feeding a funnel illustrating SEO revenue attribution",
  contact: "Speech bubbles, an envelope and a project checklist for a website consultation",
  "crawl-audit":
    "Website page hierarchy and a magnifying glass illustrating a technical SEO crawl audit",
  "creating-an-seo-plan-that-supports-long-term-success":
    "Planning document and stepping stones leading to a growing plant, illustrating an SEO roadmap",
  credentials:
    "Professional certificate, verified profile and reviews illustrating website trust signals",
  "data-driven-decisions-leveraging-ga4-for-seo-success":
    "Magnifying glass over an analytics dashboard illustrating data-led SEO reporting",
  "decoding-googles-2022-algorithm-updates":
    "Search lens with review, conversation and security signals illustrating algorithm assessment",
  development:
    "Code window, mobile interface and connected modules illustrating bespoke software development",
  "eat-and-the-evolution-of-content":
    "Open book, author medal and shield illustrating expertise and trustworthy content",
  ecommerce:
    "Online storefront, product display, basket and parcel illustrating ecommerce website design",
  "eeat-and-content-quality":
    "A hand inspecting website content with a magnifying glass, illustrating content quality",
  electricians:
    "Lightbulb, electrical tools and a service website illustrating SEO for electricians",
  "emerging-seo-specialties-aeo-geo-and-beyond":
    "Search prism connecting different answer cards, illustrating AEO and GEO search visibility",
  "enterprise-seo-and-collaboration":
    "Teams connected to a shared website illustrating collaboration on enterprise SEO",
  "firstparty-data-and-privacy":
    "Customer data protected by a locked safe, illustrating first-party data privacy",
  "generative-ai-and-content-creation-balancing-automation-and-authenticity":
    "Pen and human hand shaping content with an AI symbol, illustrating assisted content creation",
  "generative-ais-role-in-search-in-2023":
    "Search and generated-answer panels above website source cards",
  hairdressers:
    "Salon mirror, scissors, website and booking calendar illustrating SEO for hairdressers",
  hosting: "Server racks, cloud and security shield illustrating managed website hosting",
  "how-accountancy-websites-can-improve-enquiry-quality":
    "Accountancy content filtered into a qualified client profile, illustrating enquiry quality",
  "how-builders-can-get-more-quote-requests-from-google":
    "House project, plans and enquiry funnel illustrating quote requests for builders",
  "how-hairdressers-can-get-more-bookings-from-google":
    "Salon tools, phone booking calendar and location pin illustrating local salon enquiries",
  "how-law-firms-can-improve-search-led-enquiry-quality":
    "Legal scales, case files and a verified client profile illustrating law firm enquiry quality",
  "how-long-does-seo-take-in-barnsley-a-practical-timeline":
    "Local shop, search, website and enquiry milestones illustrating a Barnsley SEO timeline",
  "how-long-does-seo-take-in-sheffield-a-practical-timeline":
    "Calendars leading to website performance and an enquiry, illustrating an SEO timeline",
  "how-much-does-seo-cost-for-a-barnsley-business-in-2026":
    "Calculator, coins and a scope checklist illustrating SEO budgeting for a Barnsley business",
  "how-much-does-seo-cost-for-a-wakefield-business-in-2026":
    "Balance scale, service work and a calendar illustrating factors in Wakefield SEO pricing",
  "how-seo-builds-momentum-over-time-for-small-businesses":
    "Flywheel linked to growing website visibility and an enquiry, illustrating SEO momentum",
  "how-to-hire-an-seo-consultant":
    "SEO proposal, magnifying glass and checklist for evaluating a consultant",
  "how-to-optimise-your-google-business-profile":
    "Business listing, location pin, clock and checklist illustrating Google Business Profile optimisation",
  indexation: "Website pages organised in a search-index drawer with a validation check",
  "indexnow-and-instant-indexing":
    "Website update connected to a search-index drawer, illustrating IndexNow notifications",
  "introduction-of-mum-and-passage-ranking":
    "Image, audio and text passing through a search lens, illustrating multimodal search",
  "january-2025-quiet-month-big-insights":
    "Calendar and magnifying glass over search analytics illustrating a monthly SEO review",
  "july-2026-ai-search-what-small-businesses-should-do-now":
    "Connected website sources and an answer card illustrating AI search visibility",
  "july-2026-google-core-update-recovery-playbook":
    "Magnifying glass over search performance charts beside a traffic-recovery checklist",
  "keyword-research":
    "Search queries connected into keyword clusters with a magnifying glass for SEO research",
  legal: "Legal scales, case files and a law firm website illustrating legal SEO",
  "lessons-and-predictions-for-2022":
    "Open planning book, compass and pathway illustrating an SEO strategy review",
  "lessons-from-google-s-2025-algorithm-updates":
    "Search results, gears and a performance lens illustrating an algorithm-update review",
  "local-areas": "Conceptual Yorkshire map connecting local businesses with location pins",
  "local-search-in-2025-personalisation-and-contextual-relevance":
    "Local business listing, shop, clock and weather symbols illustrating contextual local search",
  "local-seo-and-ai-optimising-for-voice-and-community":
    "Microphone and local businesses illustrating voice search and local SEO",
  "local-seo-and-the-consumer-journey":
    "Reviews, location pin, shop and website linked in a local customer journey",
  "local-seo-enhancements-in-2023":
    "Business profile with photos, hours, reviews and a map pin illustrating local SEO",
  "local-seo-for-accountancy-firms-what-matters-most":
    "Accountancy files, calculator, office and map pin illustrating local SEO for accountants",
  "local-seo-in-2022": "Nearby shops and a location pin illustrating proximity in local search",
  "looking-ahead-lessons-from-2024-for-the-future":
    "Telescope, website pages and a path towards the horizon illustrating future SEO planning",
  maintenance: "Website, security shield, backup symbol and tools illustrating website maintenance",
  "mobile-and-core-web-vitals-in-2023":
    "Finger using a mobile page beside a speed gauge illustrating Core Web Vitals",
  "mobilefirst-indexing-gains-pace":
    "Mobile website and search-index files illustrating mobile-first indexing",
  "multi-format-content-and-diversified-channels":
    "Article linked to video, audio, images and chat illustrating a multi-format content strategy",
  "navigating-googles-2023-core-and-spam-updates":
    "Website content, shield and compass illustrating core and spam update assessment",
  "news-index": "Articles and a magnifying glass illustrating SEO and web design news",
  "november-2025-digital-marketing-trends-to-watch":
    "Search results and analytics illustrating digital marketing trend analysis",
  "omnichannel-and-social-search":
    "Phone connected to video, images, chat and content illustrating omnichannel search",
  "oracle-training-consultants-new-website":
    "Learner journeys connected to a course-booking calendar for Oracle Training Consultants",
  outreach: "Linked website articles and an envelope illustrating link-building outreach",
  "peoplefirst-content-vs-search-enginefirst":
    "Reader, open book and helpful-content checklist illustrating people-first SEO content",
  performance: "Website pages, feather and speed gauge illustrating web performance optimisation",
  "preparing-for-2021-lessons-from-2020":
    "Website foundations and a roadmap illustrating technical SEO planning",
  "private-dental-seo-treatment-pages-that-convert-patients":
    "Tooth, treatment information and booking calendar illustrating dental website content",
  "product-reviews-and-algorithm-updates":
    "Product review cards examined with a magnifying glass, illustrating review quality",
  "protecting-against-spam-and-algorithmic-penalties":
    "Shield blocking harmful links before they reach a website, illustrating SEO spam protection",
  "quality-content-and-e-e-a-t-raising-the-bar-for-trust":
    "Author profile, verified expertise and an open article illustrating content trust",
  reporting: "Website analytics dashboard and enquiry envelope illustrating SEO reporting",
  "rethinking-seo-for-2025-putting-people-before-keywords":
    "Person linked to search, video, conversations and articles illustrating people-first search",
  "salon-treatment-pages-that-improve-seo-performance":
    "Hair treatment examples, salon tools and a calendar illustrating treatment-page SEO",
  "search-in-a-pandemic-changing-user-behaviour":
    "Laptop, online search, delivery parcel and groceries illustrating changing customer search behaviour",
  "sentinel-door-systems-new-website":
    "Industrial-door product, maintenance and urgent-repair enquiry routes for Sentinel Door Systems",
  "seo-for-contractors-winning-higher-value-project-enquiries":
    "Hard hat, building plans and project website illustrating SEO for contractors",
  "seo-for-electricians-emergency-versus-planned-search-intent":
    "Emergency phone and planned electrical inspection linked through search",
  "seo-for-plumbers-emergency-boiler-and-bathroom-search-intent":
    "Separate emergency plumbing, boiler and bathroom pages linked to appropriate enquiry routes",
  "seo-in-2026-how-local-yorkshire-businesses-can-win-more-customers-from-google":
    "Yorkshire-style shops, map pins and an enquiry envelope illustrating local business SEO",
  "seo-in-an-ai-driven-search-world-what-small-businesses-need-to-focus-on":
    "AI search lens inspecting website source pages and highlighted answers",
  "seo-mistakes-that-cost-builders-local-leads":
    "Building project and website linked through repaired connections, illustrating builders SEO fixes",
  "seo-strategy":
    "Website pages, magnifying glass and checklist illustrating SEO strategy and content planning",
  "seo-strategy-for-small-businesses-building-consistent-enquiries-in-2026":
    "Search, service page, enquiry and customer connected in an SEO strategy",
  "structured-data":
    "Website content connected to validated attributes illustrating structured data for SEO",
  "structured-data-and-rich-results":
    "Structured content linked to search features and reviews, illustrating rich results",
  "tackling-zero-click-searches-turning-visibility-into-value":
    "Search answer card directing attention to a local shop, illustrating zero-click search visibility",
  "the-advent-of-zeroclick-results":
    "Search query leading to an answer card with a lightbulb, illustrating zero-click results",
  "the-rise-of-brand-seo-building-authority-for-2025":
    "Reviews, identity and links supporting a shield, illustrating brand authority in SEO",
  "the-rise-of-the-helpful-content-update":
    "Reader question, open guide and website illustrating helpful content",
  "turning-website-visitors-into-customers-with-seo":
    "Website, search and enquiry leading to a local shop, illustrating visitor conversion",
  "understanding-googles-latest-algorithm-update":
    "Search lens, algorithm gear and analytics illustrating a search-update review",
  "user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond":
    "Mobile website, page layouts and performance gauges illustrating Core Web Vitals",
  "video-and-visual-search":
    "Camera lens, video play control and image results illustrating visual search",
  "voice-and-conversational-search":
    "Microphone surrounded by speech bubbles illustrating conversational search",
  "voice-search-and-conversational-content":
    "Content page, microphone and question bubble illustrating voice-search content",
  "voice-search-and-conversational-queries-in-2023":
    "Smart speaker, spoken question and search results illustrating voice search queries",
  "volatility-and-algorithm-resilience":
    "Website with strong roots protected from volatility, illustrating SEO resilience",
  "web-design":
    "Website layouts across desktop, tablet and phone illustrating responsive web design",
  "website-redesign-seo-migration-checklist":
    "Old and new website pages connected by redirects beside an SEO migration checklist",
  "why-consistency-matters-more-than-quick-wins-in-seo":
    "Calendar and completed milestones illustrating consistent SEO work",
  "why-seo-is-still-one-of-the-best-investments-for-growing-businesses":
    "Search visibility and coin stacks illustrating investment in organic search",
  "why-seo-should-be-driving-your-business-growth-not-just-rankings":
    "Search result linked to enquiries and customers, illustrating SEO business outcomes",
  "why-seo-starts-with-your-website-and-always-will":
    "Website connected to marketing channels illustrating the foundations of SEO",
  wordpress:
    "Content editor and responsive website previews illustrating WordPress website management",
  "local-search-barnsley":
    "Yorkshire-style shops, a workshop and location pins illustrating local SEO for Barnsley businesses",
  "about-seo-portrait":
    "Search queries, website layouts and validation checks illustrating SEO and web design planning",
};

export function describeImage(src: string, fallback: string): string {
  const key = src
    .split("/")
    .pop()
    ?.split("?")[0]
    .replace(/-(?:480|800|1200)\.webp$/, "")
    .replace(/-banner\.webp$/, "")
    .replace(/\.(?:jpg|png|webp|avif)$/, "");
  return (key && imageDescriptions[key]) || fallback;
}
